import Button from '@components/common/Button';
import './ChildDetailsSelectionTable.css';
import React, { useEffect } from 'react';
import { useState } from 'react';
import InfoBar from '@components/common/InfoBars';
import { RootState } from '@store/reducers';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

interface showModalProps {
  childData: any;
  handleChildTableSubmit:(childData:any) => void;
  handleBack: () => void;
  handleDiscard: () => void;
  onClose: () => void;
  showModal: boolean;
}

 
const ChildDetailsSelectionTable = (props:showModalProps) => {
  const {childData, handleChildTableSubmit, handleBack, handleDiscard, onClose, showModal} = props;
  const [hoveredIndex, setHoveredIndex] = useState<number>(-1);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const childBALAbhaId = useSelector((state: RootState) => state.beneficiary?.childBALAbhaId);
  const childBALAbhaIds = useSelector((state: RootState) => state.beneficiary?.childBALABHAIds);
  const [isChildExists,setIsChildExists] = useState(false);
 
  const handleRowClick = (index: number, rowData: any) => {
    setSelectedIndex(index);
  }; 


  const handleTableSubmit = (selectedChild:any) => {
    if(childBALAbhaIds.includes(selectedChild.ABHANumber.split('-').join(''))) {
      setIsChildExists(true);
      return;
    }
    setIsChildExists(false);
    handleChildTableSubmit(selectedChild);
  }

 
  return (
    <div className="modal_verification_beneficiaries">
      <Modal
        show={showModal}
        onHide={() => onClose()}
        dialogClassName={'child-verification-card-table-modal'}
        centered={true}
        backdrop = "static"
      >
        <Modal.Body>
          <div className="modal-body-header">
            <div className="modal-body-back" onClick={handleBack}>
              <i className="bi bi-arrow-left"></i>
              <span className="ms-1">Back</span>
            </div>
            <div className="modal-body-discard" onClick={handleDiscard}>
              <span className="me-0">Discard</span>
              <i className="bi bi-x"></i>
            </div>
          </div>
          <div className="child_modal">
            {childData ? (
              <>
                <div className="child_modal_headers">
                  <p>Name</p>
                  <p>Gender</p>
                  <p>ABHA Number</p>
                  <p>DOB</p>
                </div>
                {childData?.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className="child_table_modal"
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(-1)}
                      onClick={() => handleRowClick(index, item)}
                      style={{
                        backgroundColor:
                          selectedIndex === index
                            ? '#A9328D'
                            : hoveredIndex === index
                              ? '#e69dde'
                              : '',
                        color: selectedIndex === index ? 'white' : '',
                      }}
                    >
                      <p>{item?.name}</p>
                      <p>{item?.gender === 'M' ? 'Male' : 'Female'}</p>
                      <p>{item?.ABHANumber.split('-').join('')}</p>
                      <p>{item?.dateOfBirth}</p>
                    </div>
                  );
                })}
                {isChildExists && (
                  <InfoBar
                    variant="danger"
                    message={
                      'Selected child already registered, please select other child.'
                    }
                    className="input_field_class"
                  />
                )}
                <div className="child_table_button">
                  <Button
                    onClick={() => onClose()}
                    disabled={false}
                    id=""
                    buttonName={'Cancel'}
                    colorType={'cancel'}
                    icon={''}
                    iconPosition={''}
                  />
                  <Button
                    onClick={() => handleTableSubmit(childData[selectedIndex])}
                    disabled={selectedIndex === -1}
                    id=""
                    buttonName={'Submit'}
                    colorType={'primary'}
                    icon={''}
                    iconPosition={''}
                  />
                </div>
              </>
            ) : (
              <h4 style={{ fontWeight: '400', margin: '30px 0px 30px 133px' }}>
                No child registered.
              </h4>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
 
export default ChildDetailsSelectionTable;